import React from 'react';

export const TermsOfUse = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-24 max-w-4xl">
      <h1 className="text-4xl md:text-6xl font-bold text-primary mb-12 tracking-tight">Termos de Uso</h1>
      
      <div className="prose prose-slate max-w-none space-y-8 text-slate-600 leading-relaxed">
        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e usar este site da Escola Estadual 8 de Maio, você concorda em cumprir e estar vinculado aos seguintes termos e condições de uso. Se você não concordar com qualquer parte destes termos, não deverá utilizar nosso site.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">2. Uso do Site</h2>
          <p>
            O conteúdo deste site é apenas para sua informação geral e uso pessoal. Ele está sujeito a alterações sem aviso prévio. É proibido o uso indevido deste site, incluindo a tentativa de acesso a áreas restritas ou a interferência em seu funcionamento.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">3. Propriedade Intelectual</h2>
          <p>
            Este site contém material que é de nossa propriedade ou licenciado para nós. Este material inclui, mas não se limita ao design, layout, aparência e gráficos. A reprodução é proibida, exceto de acordo com o aviso de direitos autorais.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-primary">4. Limitação de Responsabilidade</h2>
          <p>
            A Associação de Pais e Mestres não será responsável por quaisquer danos diretos, indiretos, incidentais ou consequentes resultantes do uso ou da incapacidade de usar este site ou seu conteúdo.
          </p>
        </section>

        <p className="text-sm text-slate-400 pt-8 border-t border-slate-100">
          Última atualização: 13 de Março de 2026.
        </p>
      </div>
    </div>
  );
};
